import React from "react";
import Pillar from "../conponents/Pillar";

const Mission = () => {
  const pillarArray = [
    {
      id: 1,
      letter: "I",
      topic: "Innovation",
      description:
        "We're constantly pushing the boundaries of cloud technology along with artificial intelligence to deliver novel solutions.",
      color: "bg-[#7E95A7]",
    },
    {
      id: 2,
      letter: "D",
      topic: "Dynamic",
      description:
        "Energetic and proactive, we're always moving forward in pursuit of our vision and mission.",
      color: "bg-[#758A9A]",
    },
    {
      id: 3,
      letter: "I",
      topic: "Integrity",
      description:
        "We hold ourselves to the highest standards in everything we do.",
      color: "bg-[#5C7487]",
    },
    {
      id: 4,
      letter: "A",
      topic: "Affordability",
      description:
        "We're committed to keeping our technology accessible through low subscription fees.",
      color: "bg-[#485E6F]",
    },
  ];

  return (
    <div className="max-w-screen flex flex-col justify-center items-center py-40">
      <div className="w-[80%] md:w-[70%] flex flex-col justify-center items-center gap-2 md:gap-3 lg:gap-5">
        <p className="text-2xl md:text-3xl font-semibold tracking-[10px] my-0">
          MISSION
        </p>
        <p className="text-xl md:text-2xl font-medium text-center my-2">
          To offer cloud-based solutions powered by AI that revolutionises
          problem-solving across the globe. With a commitment to affordability
          through low subscription fees, a lean infrastructure, and leveraging
          development expertise from Asia, alongside consultation with global
          thought leaders, to make high-tech solutions accessible to all.
        </p>
      </div>

      <div className="mt-36">
        <div className="flex flex-col justify-center items-center">
          <p className="text-5xl md:text-6xl font-bold pb-10 font-syne my-0">
            Idia Pillars
          </p>
          <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-1 px-10">
            {pillarArray.map((item, index) => {
              return <Pillar key={index} pillarArray={item} />;
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mission;
